/**
 * Vue Flow types `domAttributes` loosely; both workflow canvases (`TaskGraph.vue`, `PlanGraph.vue`)
 * attach plain `data-*` attributes to a node or edge and need them cast to the HTML/SVG attribute
 * type Vue Flow expects at that call site. A tiny, shared cast beats each canvas re-declaring its
 * own identical helper.
 */
export function dataAttributes<T>(attributes: Record<string, string>): T {
    return attributes as T
}
